export const GalleryDefaultValue: IGalleryItem["get"] = {
    id: 0,
    categories: [],
    products: [],
    description: "",
    file: "",
    thumbnail: "",
    title: "",
    type: "image",
    createDateTime: "",
    updateDateTime: "",
};
